'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Quickbooks = (_temp = _class = function (_SvgIcon) {
  _inherits(Quickbooks, _SvgIcon);

  function Quickbooks() {
    _classCallCheck(this, Quickbooks);

    return _possibleConstructorReturn(this, (Quickbooks.__proto__ || Object.getPrototypeOf(Quickbooks)).apply(this, arguments));
  }

  _createClass(Quickbooks, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2['default'].createElement('path', {
              d: 'M.452 60.712C.452 27.516 27.36.608 60.557.608c33.196 0 60.104 26.908 60.104 60.104 0 33.197-26.908 60.105-60.104 60.105C27.36 120.817.452 93.909.452 60.712',
              fill: '#2B9A47'
            }),
            _react2['default'].createElement('path', {
              d: 'M80.597 37.344h-3.34v8.682h3.34c8.103 0 14.692 6.589 14.692 14.692 0 8.097-6.59 14.687-14.692 14.687h-8.025V29.998a8.679 8.679 0 0 0-8.682-8.682v62.776h16.707c12.911 0 23.374-10.468 23.374-23.374 0-12.911-10.463-23.374-23.374-23.374zM17.142 60.712c0 12.912 10.463 23.374 23.374 23.374h3.34v-8.681h-3.34c-8.103 0-14.692-6.59-14.692-14.693s6.59-14.692 14.692-14.692h8.025v45.412a8.682 8.682 0 0 0 8.682 8.682V37.338H40.516c-12.911 0-23.374 10.463-23.374 23.374z',
              fill: '#FFFFFE'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return Quickbooks;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 121 121'
}, _temp);
exports['default'] = Quickbooks;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Quickbooks.js
// module id = 1376
// module chunks = 32